import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import ModalComponent from './Modal'
import Confirmation from '../../components/Confirmation/Confirmation'
import { deleteManners, getJournalControl, getJournalMannersList, getMannersList } from '../../actions/directoryBasicEducation'
import { getTermsList } from '../../actions/terms'
import { getSchoolYearsList } from '../../actions/schoolYears'
import moment from 'moment'
import { getCurrentYearUtils, getCurrentTermUtils } from '../../utils/classBook'
import TeacherInfo from '../Classbook/TeacherInfo/TeacherInfo'
import CustomSelect from '../../components/CustomSelect'
import { useFormik } from 'formik'
import { arrayForSelect } from '../../utils/arrayForSelect'
import { getCLasses, getCLassesByYear } from '../../actions/common'
import Modal from 'react-responsive-modal'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import userPhoto from '../../assets/images/user_photo.png'
import { getStudentMain } from '../../actions/students/main'
import { getStudentOtherData } from '../../actions/students/other'





export default function JournalManners() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { mannersList, journalControl, journalMannersList } = useSelector(state => state.directoryBasicEducation)

  const { list: yearList } = useSelector(state => state.school_years)
  const { list: termList } = useSelector(state => state.terms)
  const { classes } = useSelector(state => state.common);
  const { main, lang } = useSelector(state => state.students.data);
  const [selectedItem, setSelectedItem] = useState(null)
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [data, setData] = useState();
  const [classSel, setClassSel] = useState();
  const [scYear, setScYear] = useState()
  const [termSel, setTermSel] = useState()
  const [curManners, setCurManners] = useState()

  const fio = journalMannersList?.teachers[0]
  const teacherFIO = `${fio?.lastname} ${fio?.firstname} ${fio?.patronymic}`

  useEffect(() => {
    dispatch(getSchoolYearsList())
    dispatch(getMannersList())
  }, [])

  useEffect(() => {
    yearList && setScYear(getCurrentYearUtils(yearList, moment()))
    // setTermSel(getCurrentPeriodUtils(scYear))
  }, [yearList])

  useEffect(() => {
    // yearList && setScYear(getCurrentYearUtils( yearList, moment()))
    // !!termList &&  setTermSel(getCurrentPeriodUtils(termList))
    if (termList) {
      const termListResult = getCurrentTermUtils(termList, moment())
      setTermSel(termListResult[0] || null)
    }
  }, [termList])

  useEffect(() => {
    classes && setData(classes)
  }, [classes])

  useEffect(() => {
    selectedStudent && dispatch(getStudentMain(selectedStudent.mid))
    selectedStudent && dispatch(getStudentOtherData('lang', selectedStudent.mid))
  }, [selectedStudent])

  const {
    values,
    handleChange,
    setFieldValue
  } = useFormik({
    initialValues: {},
  })

  useEffect(() => {
    values.xp_key && dispatch(getTermsList(values.xp_key))
    !!values.trmid && values.xp_key && setFieldValue('trmid', 0)
    !classes && dispatch(getCLassesByYear(values.xp_key))
  }, [values.xp_key])

  useEffect(() => {
    values.trmid && dispatch(getJournalControl({ trmid: values.trmid }))
  }, [values.trmid])

  useEffect(() => {
  }, [classSel])

  useEffect(() => {
    selectedStudent && dispatch(getStudentMain(selectedStudent.mid))
  }, [selectedStudent])

  useEffect(() => {
    const { manner_id, group_id, trimestr } = values
    manner_id && group_id && trimestr && dispatch(getJournalMannersList(values))

  }, [values])

  useEffect(() => {
    curManners && dispatch(getJournalMannersList({ trimestr: termSel, manner_id: curManners, group_id: classSel }))
  }, [curManners])

  const openModal = (data) => () => {
    setSelectedItem(data || {})
    termSel && classSel && dispatch(getJournalMannersList(values))
  }

  const closeModal = () => {
    setSelectedItem(null)
    setSelectedStudent(null)
  }

  const goHome = () => navigate('/')

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteManners(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const handleSelectStudent = (el) => {
    setSelectedStudent(el)
  }

  return (
    <div className={styles.wrapper} style={{ width: '80vw', margin: '0 auto' }}>
      {selectedStudent &&
        <ModalStudent
          closeModal={closeModal}
          data={selectedStudent}
          main={main}
          lang={lang[0]}
        />
      }
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <ModalComponent
          closeModal={closeModal}
          data={selectedItem}
          height={'430px'}
          addMode={!selectedItem.name}
        />
      }
      <h1>Журнал воспитанности</h1>
      <div>

        <CustomSelect
          title="Учебный год"
          options={yearList && arrayForSelect(yearList, 'name', 'xp_key')}
          valuesName="xp_key"
          setFieldValue={setFieldValue}
        />

        <CustomSelect
          title="Учебный период"
          valuesName="trimestr"
          options={termList ? arrayForSelect(termList, 'title', 'trmid') : [{ name: "Необходимо выбрать учебный год", trmid: 0 }]}
          setFieldValue={setFieldValue}
        />

        <CustomSelect
          title="Критерии"
          valuesName="manner_id"
          options={mannersList && arrayForSelect(mannersList, 'name', 'id')}
          // onChange={handleChange}
          setFieldValue={setFieldValue}
        />
        <CustomSelect
          title="Класс"
          valuesName="group_id"
          options={!!data?.length && arrayForSelect(data, 'name', 'gid')}
          setFieldValue={setFieldValue}
          disabled={!data?.length}
        />

        {journalMannersList && <TeacherInfo
          teacher_fio={teacherFIO}
        />}

      </div>

      {
        journalMannersList &&
        <JournalMannersTable
          classbook={journalMannersList.journal_result}
          handleSelectStudent={handleSelectStudent}
        />
      }
    </div>
  )
}


const JournalMannersTable = ({ classbook, handleSelectStudent }) => {
  const allWeeks = classbook.map(week => week.week_id)
  const weeks = Array.from(new Set(allWeeks));

  const dateWeeks = weeks.map((date, i) => classbook.find(el => el.week_id === date))

  const uniqStud = (options) => {
    return options.reduce(
      (res, cur) =>
        res.find((find) => JSON.stringify(find.mid) === JSON.stringify(cur.mid))
          ? res
          : [...res, cur],
      []
    )
  };
  const listStudent = (uniqStud(classbook).filter((el) => el.mid !== 99999))
  const avBall = uniqStud(classbook).find((el) => el.mid === 99999)
  const listAll = [...listStudent, avBall]

  const handleOpenModal = (data) => {

  }

  return (
    <>
      <div >

        <div className={styles.tableJournal}>
          <br />
          <table style={{ borderCollapse: 'collapse', }}>
            <thead style={{
              border: "1px solid black",
              textAlign: "left",
              fontSize: '13px',
            }}>
              <tr>
                <td rowSpan={2} style={{ width: "70px", textAlign: "center" }} bgcolor="#85aee7">№ п.п.</td>
                <td rowSpan={2} style={{ backgroundColor: "#85aee7", textAlign: "center" }}>Фамилия И.О.</td>
                <td colSpan={weeks.length - 1} bgcolor="#85aee7" style={{ textAlign: 'center' }} >Недели</td>
                <td bgcolor="#85aee7" style={{ textAlign: 'center' }} >Итоги</td>

              </tr>
              <tr>
                {!!dateWeeks && dateWeeks.map(week =>
                  <td
                    onClick={() => handleOpenModal(week)}
                    bgcolor="#85aee7"
                    style={{ textAlign: 'center' }}
                  >
                    {week.weekstart !== null ?
                      (
                        <>
                          {moment(week.weekstart).format("DD.MM")}
                          < br />
                          {moment(week.weekend).format("DD.MM")}
                        </>
                      )
                      : week.weekname
                    }
                  </td>
                )}
              </tr>
            </thead>
            <tbody>
              {!!listAll.length &&
                listAll.map((el, i) => {
                  const allStudentGrades = classbook.filter((student) => student.mid === el.mid)
                  return (
                    <tr>
                      {el.student !== "Ср. балл" ?
                        <td style={{ border: "1px solid black", width: "70px", textAlign: "center", }}>{i + 1}</td>
                        :
                        <td></td>
                      }
                      <td
                        className={styles.student}
                        style={{
                          border: "1px solid black",
                          textAlign: "left",
                          fontSize: '13px',
                          cursor: 'pointer'
                        }}
                        onClick={() => handleSelectStudent(el)}
                      >
                        {el.student}
                      </td>
                      {dateWeeks.map(({ week_id }, i) => {
                        let grade = allStudentGrades.find((grade) => grade.week_id === week_id)
                        return (

                          <td style={{ border: "1px solid black", width: "70px", textAlign: "center" }}>{grade?.grade !== null ? grade?.grade : ''}</td>
                        )
                      })}
                    </tr>
                  )
                })


              }
            </tbody>
          </table>
        </div>


      </div >
      < footer className={
        styles.footer
      } > <div className={styles.buttons}>
          <div className={styles.export}>
            <i>
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_477_4116)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.16797 1.5039C2.33525 2.0523 0.0136406 2.50163 0.00878906 2.50244C0.0039375 2.50325 0 5.65184 0 9.49934V16.4948L0.0791016 16.5136C0.12259 16.5239 2.42051 16.9669 5.18555 17.4981C7.95059 18.0292 10.2485 18.4722 10.292 18.4826L10.3711 18.5013V9.50068C10.3711 4.55033 10.3592 0.501555 10.3447 0.503419C10.3302 0.505282 8.00068 0.955493 5.16797 1.5039ZM11.0742 3.61134V4.64845H12.1289H13.1836V5.35157V6.0547H12.1289H11.0742V6.74024V7.42579H12.1113H13.1484V8.11134V8.79688H12.1113H11.0742V9.50001V10.2031H12.1113H13.1484V10.8887V11.5742H12.1113H11.0742V12.2598V12.9453H12.1113H13.1484V13.6484V14.3516H12.1113H11.0742V15.3887V16.4258H14.2921C16.9464 16.4258 17.5299 16.4173 17.6232 16.3774C17.76 16.3188 17.9117 16.1627 17.9626 16.028C17.9885 15.9594 18 13.9559 18 9.4966C18 4.1128 17.9921 3.04571 17.9516 2.95103C17.8931 2.8142 17.7369 2.6625 17.6022 2.61163C17.5349 2.58618 16.4744 2.57423 14.2887 2.57423H11.0742V3.61134ZM13.8516 5.35199V6.0555L15.2314 6.04633L16.6113 6.03712L16.6209 5.34278L16.6304 4.64845H15.241H13.8516V5.35199ZM2.22887 6.16895C2.27689 6.25115 2.73519 7.03682 3.24731 7.91492L4.17843 9.51147L4.05257 9.70789C3.19275 11.0496 1.96875 12.9811 1.96875 12.9962C1.96875 13.0069 2.38676 13.0156 2.89768 13.0156H3.82662L4.43166 11.8869C4.76445 11.2662 5.07234 10.6563 5.11594 10.5316C5.1595 10.4069 5.20214 10.2979 5.21072 10.2893C5.21926 10.2808 5.24528 10.3561 5.26852 10.4568C5.31323 10.6505 6.5192 12.9751 6.58884 13.0018C6.61043 13.0101 7.03375 13.0126 7.52955 13.0074L8.431 12.9981L7.37648 11.2754C6.79651 10.3279 6.31406 9.53376 6.30439 9.51059C6.29473 9.48742 6.74891 8.70432 7.31366 7.77036C7.87845 6.83639 8.34764 6.06014 8.35629 6.04531C8.36497 6.03047 7.97446 6.02256 7.48846 6.02773L6.60484 6.03712L6.07514 7.02149C5.7838 7.5629 5.48571 8.16407 5.41269 8.35743C5.33482 8.56366 5.27147 8.6872 5.25948 8.65626C5.24823 8.62725 5.20741 8.51064 5.16878 8.39709C5.13011 8.28357 4.86577 7.70215 4.58135 7.10509L4.06417 6.01954H3.10286H2.14158L2.22887 6.16895ZM13.8516 8.11134V8.79688H15.2402H16.6289V8.11134V7.42579H15.2402H13.8516V8.11134ZM13.8516 10.8887V11.5742H15.2402H16.6289V10.8887V10.2031H15.2402H13.8516V10.8887ZM13.8516 13.648V14.3516H15.241H16.6304L16.6209 13.6572L16.6113 12.9629L15.2314 12.9537L13.8516 12.9445V13.648Z"
                    fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_477_4116">
                    <rect width="18" height="18" fill="white" transform="translate(0 0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </i>
            <span>Экпорт в Excel</span>
          </div>

          <div className={styles.export}>
            <i>
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_477_4122)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.58858 1.26446C3.43857 1.34117 3.34484 1.46633 3.30332 1.64524C3.28574 1.7211 3.27098 2.51388 3.27052 3.40695L3.26968 5.03075L2.11743 5.04172L0.965219 5.05269L0.733258 5.16694C0.45823 5.3024 0.24216 5.52315 0.111238 5.80239L0.0177227 6.0019V9.76362C0.0177227 12.6963 0.0275312 13.5576 0.0621953 13.6717C0.161652 13.9989 0.502492 14.3518 0.843895 14.4809C0.977805 14.5316 1.17598 14.5428 2.13406 14.5542L3.26602 14.5676L3.27664 15.9801C3.28669 17.3188 3.29091 17.3988 3.35757 17.5119C3.39624 17.5776 3.47253 17.6646 3.52712 17.7052L3.62641 17.7792H9.00014H14.3739L14.4732 17.7052C14.5278 17.6646 14.6041 17.5776 14.6427 17.5119C14.7094 17.3988 14.7136 17.3188 14.7237 15.9775L14.7343 14.5625H15.7472C16.3043 14.5625 16.8447 14.5464 16.9482 14.5268C17.4486 14.4319 17.8801 14.0248 17.9511 13.5805C17.9638 13.501 17.988 13.4274 18.0047 13.417C18.0217 13.4065 18.0353 11.7729 18.0353 9.7419C18.0353 7.31334 18.0235 6.09292 18.0001 6.10737C17.9804 6.11954 17.965 6.09204 17.965 6.04476C17.965 5.90259 17.761 5.54266 17.5923 5.38713C17.5043 5.30606 17.3426 5.19767 17.2329 5.1462L17.0333 5.05269L15.8835 5.04172L14.7337 5.03078L14.7234 3.31906C14.7135 1.68067 14.71 1.60228 14.6427 1.48802C14.6041 1.42235 14.5278 1.33533 14.4732 1.29466L14.3739 1.22065L9.04152 1.21172C4.01784 1.20332 3.70213 1.20638 3.58858 1.26446ZM4.35952 3.66401V5.03511H9.00014H13.6408V3.66401V2.29292H9.00014H4.35952V3.66401ZM0.0170898 9.7812C0.0170898 11.8018 0.0213086 12.6284 0.0265117 11.6181C0.0316797 10.6078 0.0316797 8.95457 0.0265117 7.94429C0.0213086 6.93397 0.0170898 7.7606 0.0170898 9.7812ZM1.14817 6.18925C1.09484 6.24817 1.08999 6.54964 1.08999 9.8049C1.08999 13.2007 1.0928 13.3588 1.15429 13.4144C1.211 13.4658 1.33904 13.4726 2.24227 13.4726H3.26598L3.27664 12.0576C3.2868 10.7037 3.29038 10.6372 3.35946 10.5196C3.39919 10.452 3.48459 10.361 3.54924 10.3174L3.6668 10.2382H9.00014H14.3335L14.4511 10.3174C14.5157 10.361 14.6011 10.452 14.6408 10.5196C14.7099 10.6372 14.7135 10.7037 14.7237 12.0576L14.7343 13.4726H15.7641C16.7172 13.4726 16.7983 13.4678 16.8521 13.4083C16.9054 13.3494 16.9103 13.0479 16.9103 9.79266C16.9103 6.39681 16.9075 6.23879 16.846 6.18313C16.7866 6.12935 16.1912 6.12495 8.99403 6.12495C1.49411 6.12495 1.20421 6.12734 1.14817 6.18925ZM14.0099 7.42271C13.6201 7.52037 13.3538 7.89285 13.4043 8.26962C13.4312 8.47005 13.5853 8.71238 13.757 8.82397C13.885 8.90722 13.9399 8.91987 14.1739 8.91987C14.4161 8.91987 14.4587 8.90922 14.5958 8.81419C14.774 8.69062 14.9417 8.39344 14.9413 8.20167C14.9409 7.90045 14.7614 7.6025 14.5101 7.48571C14.3625 7.41715 14.1426 7.38945 14.0099 7.42271ZM4.35952 14.0175V16.707H9.00014H13.6408V14.0175V11.3281H9.00014H4.35952V14.0175ZM6.30893 12.4319C6.1636 12.4956 6.0197 12.6744 5.99112 12.8266C5.94057 13.0962 6.14669 13.4078 6.40663 13.4547C6.46988 13.4662 7.67932 13.4709 9.09426 13.4653C11.6297 13.4552 11.6683 13.454 11.764 13.3825C11.9435 13.2485 12.006 13.131 12.006 12.9277C12.006 12.7243 11.9435 12.6069 11.764 12.4728C11.6682 12.4013 11.6322 12.4002 9.04152 12.3926C6.9126 12.3863 6.39587 12.3937 6.30893 12.4319ZM6.25827 14.6277C6.12363 14.6999 5.97671 14.94 5.97671 15.0879C5.97671 15.2383 6.12292 15.4855 6.25796 15.5636C6.37847 15.6332 6.43511 15.6347 9.00014 15.6347C11.5652 15.6347 11.6218 15.6332 11.7423 15.5636C11.8774 15.4855 12.0236 15.2383 12.0236 15.0879C12.0236 14.94 11.8767 14.6999 11.742 14.6277C11.6267 14.5658 11.4851 14.5625 9.00014 14.5625C6.51516 14.5625 6.37362 14.5658 6.25827 14.6277Z"
                    fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_477_4122">
                    <rect width="18" height="18" fill="white" transform="translate(0 0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </i>
            <span>Удалить оценки на дату</span>
          </div>

          <div className={styles.export}>
            <i>
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_477_4124)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.58858 1.26446C3.43857 1.34117 3.34484 1.46633 3.30332 1.64524C3.28574 1.7211 3.27098 2.51388 3.27052 3.40695L3.26968 5.03075L2.11743 5.04172L0.965219 5.05269L0.733258 5.16694C0.45823 5.3024 0.24216 5.52315 0.111238 5.80239L0.0177227 6.0019V9.76362C0.0177227 12.6963 0.0275312 13.5576 0.0621953 13.6717C0.161652 13.9989 0.502492 14.3518 0.843895 14.4809C0.977805 14.5316 1.17598 14.5428 2.13406 14.5542L3.26602 14.5676L3.27664 15.9801C3.28669 17.3188 3.29091 17.3988 3.35757 17.5119C3.39624 17.5776 3.47253 17.6646 3.52712 17.7052L3.62641 17.7792H9.00014H14.3739L14.4732 17.7052C14.5278 17.6646 14.6041 17.5776 14.6427 17.5119C14.7094 17.3988 14.7136 17.3188 14.7237 15.9775L14.7343 14.5625H15.7472C16.3043 14.5625 16.8447 14.5464 16.9482 14.5268C17.4486 14.4319 17.8801 14.0248 17.9511 13.5805C17.9638 13.501 17.988 13.4274 18.0047 13.417C18.0217 13.4065 18.0353 11.7729 18.0353 9.7419C18.0353 7.31334 18.0235 6.09292 18.0001 6.10737C17.9804 6.11954 17.965 6.09204 17.965 6.04476C17.965 5.90259 17.761 5.54266 17.5923 5.38713C17.5043 5.30606 17.3426 5.19767 17.2329 5.1462L17.0333 5.05269L15.8835 5.04172L14.7337 5.03078L14.7234 3.31906C14.7135 1.68067 14.71 1.60228 14.6427 1.48802C14.6041 1.42235 14.5278 1.33533 14.4732 1.29466L14.3739 1.22065L9.04152 1.21172C4.01784 1.20332 3.70213 1.20638 3.58858 1.26446ZM4.35952 3.66401V5.03511H9.00014H13.6408V3.66401V2.29292H9.00014H4.35952V3.66401ZM0.0170898 9.7812C0.0170898 11.8018 0.0213086 12.6284 0.0265117 11.6181C0.0316797 10.6078 0.0316797 8.95457 0.0265117 7.94429C0.0213086 6.93397 0.0170898 7.7606 0.0170898 9.7812ZM1.14817 6.18925C1.09484 6.24817 1.08999 6.54964 1.08999 9.8049C1.08999 13.2007 1.0928 13.3588 1.15429 13.4144C1.211 13.4658 1.33904 13.4726 2.24227 13.4726H3.26598L3.27664 12.0576C3.2868 10.7037 3.29038 10.6372 3.35946 10.5196C3.39919 10.452 3.48459 10.361 3.54924 10.3174L3.6668 10.2382H9.00014H14.3335L14.4511 10.3174C14.5157 10.361 14.6011 10.452 14.6408 10.5196C14.7099 10.6372 14.7135 10.7037 14.7237 12.0576L14.7343 13.4726H15.7641C16.7172 13.4726 16.7983 13.4678 16.8521 13.4083C16.9054 13.3494 16.9103 13.0479 16.9103 9.79266C16.9103 6.39681 16.9075 6.23879 16.846 6.18313C16.7866 6.12935 16.1912 6.12495 8.99403 6.12495C1.49411 6.12495 1.20421 6.12734 1.14817 6.18925ZM14.0099 7.42271C13.6201 7.52037 13.3538 7.89285 13.4043 8.26962C13.4312 8.47005 13.5853 8.71238 13.757 8.82397C13.885 8.90722 13.9399 8.91987 14.1739 8.91987C14.4161 8.91987 14.4587 8.90922 14.5958 8.81419C14.774 8.69062 14.9417 8.39344 14.9413 8.20167C14.9409 7.90045 14.7614 7.6025 14.5101 7.48571C14.3625 7.41715 14.1426 7.38945 14.0099 7.42271ZM4.35952 14.0175V16.707H9.00014H13.6408V14.0175V11.3281H9.00014H4.35952V14.0175ZM6.30893 12.4319C6.1636 12.4956 6.0197 12.6744 5.99112 12.8266C5.94057 13.0962 6.14669 13.4078 6.40663 13.4547C6.46988 13.4662 7.67932 13.4709 9.09426 13.4653C11.6297 13.4552 11.6683 13.454 11.764 13.3825C11.9435 13.2485 12.006 13.131 12.006 12.9277C12.006 12.7243 11.9435 12.6069 11.764 12.4728C11.6682 12.4013 11.6322 12.4002 9.04152 12.3926C6.9126 12.3863 6.39587 12.3937 6.30893 12.4319ZM6.25827 14.6277C6.12363 14.6999 5.97671 14.94 5.97671 15.0879C5.97671 15.2383 6.12292 15.4855 6.25796 15.5636C6.37847 15.6332 6.43511 15.6347 9.00014 15.6347C11.5652 15.6347 11.6218 15.6332 11.7423 15.5636C11.8774 15.4855 12.0236 15.2383 12.0236 15.0879C12.0236 14.94 11.8767 14.6999 11.742 14.6277C11.6267 14.5658 11.4851 14.5625 9.00014 14.5625C6.51516 14.5625 6.37362 14.5658 6.25827 14.6277Z"
                    fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_477_4124">
                    <rect width="18" height="18" fill="white" transform="translate(0 0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </i>
            <span>Комментарий к оценке</span>
          </div>


        </div> <Link className={styles.close} to='/'><Button mode='white'>Закрыть</Button></Link>
      </footer>
    </>
  )
}


const ModalStudent = ({ data, closeModal, main, lang }) => {

  const { student, } = data
  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      center
      classNames={{
        modal: styles.custom
      }}>
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >
            <div className={styles.inputsRow}>

              <div style={{ width: '200px', height: '200px' }}>
                <img src={userPhoto} alt="o_O" />
              </div>

              <div className={styles.inputsColumn}>

                <h2>{student}</h2>
                <p>Год рождения: <span style={{ marginLeft: '20px' }}>{main.birthdate || '____'}</span></p>
                <p>Место рождения:<span style={{ marginLeft: '20px' }}>{main.address || '____'}</span> </p>
                <p>Языки: <span style={{ marginLeft: '20px' }}>{lang.course_name}</span> </p>
                <p>Ср. балл: <span style={{ marginLeft: '20px' }}>{main.address || '____'}</span></p>

                <Button style={{ width: '120px', padding: '0px', fontSize: '12px', marginLeft: '200px' }}>Показатели физ. подготовки</Button>
              </div>
            </div>
          </div>
        </div>
        <ModalFooter closeModal={closeModal} />

      </>

    </Modal>
  )
}